<template>
    <div class>
        <div class="page-cnt">
            <div class="left-sidebar">
                <div class="left-cnt">
                    <form class="form-search" @submit.stop.prevent="searchTour">
                        <the-mask
                            :mask="['######-###']"
                            masked="masked"
                            v-model="keyword_search"
                            name
                            class="form-control search-tour"
                            placeholder="XXXXXX-XXX"
                            value
                        />
                        <button class="btn btn-search-cir" type="formSubmit">
                            <i class="icon-search-w"></i>
                        </button>
                    </form>
                </div>
                <div class="notify-box" v-if="isNotify">
                    <div class="header">
                        <i class="icon-notify"></i>
                        <div class="notify-title">{{$t('notify.title')}}</div>
                    </div>
                    <div class="body">
                        <div class="title">
                            {{ infos.title }}
                        </div>
                        <div v-html="infos.body"></div>
                    </div>
                </div>
                <div class="notify-box" v-else>
                    <div class="no-show-header">
                        <i class="icon-notify-no-show"></i>
                        <div class="notify-title">{{$t('notify.title')}}</div>
                    </div>
                    <div class="no-show-body">
                        {{$t('notify.no-show')}}
                    </div>
                </div>
                <div class="login-info-box" v-if="user">
                    <div class="login-info pb-2">
                        <div class="row no-gutters mt-2">
                            <div class="col-5 pl-3">{{$t('login_info.last_login_date')}}</div>
                            <div class="col-7 pl-1">{{user.last_login}}</div>
                        </div>
                        <div class="row no-gutters mt-2">
                            <div class="col-5 pl-3">{{$t('login_info.last_update_pass_date')}}</div>
                            <div class="col-7 pl-1">{{user.last_update_pass_time}}</div>
                        </div>
                    </div>

                    <div class="mt-3 text-center">
                        操作方法などわからないことあれば<br>
                        <a :href="$t('chatbot.url')" target="_blank">証憑類電子化チャットボット</a>へ
                    </div>
                </div>
            </div>
            <div class="main-cnt">
                <div class="content-white">
                    <div class="content-header">
                        <table class="table table-header">
                            <tr>
                                <td>
                                    <div class="tb-cnt-tr">
                                        <label class="tb-cnt-lb">{{$t('tour.tour_number')}}</label>
                                        <div class="tb-cnt-txt"></div>
                                    </div>
                                </td>
                                <td>
                                    <div class="tb-cnt-tr">
                                        <label class="tb-cnt-lb">{{$t('tour.departure_date')}}</label>
                                        <div class="tb-cnt-txt"></div>
                                    </div>
                                </td>
                                <td>
                                    <div class="tb-cnt-tr">
                                        <label class="tb-cnt-lb">{{$t('tour.person_count')}}</label>
                                        <div class="tb-cnt-txt"></div>
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                  <div class="tb-cnt-tr">
                                        <label class="tb-cnt-lb">{{$t('tour.tour_name')}}</label>
                                        <div class="tb-cnt-txt"></div>
                                    </div>
                                </td>
                                <td>
                                    <div class="tb-cnt-tr">
                                        <label class="tb-cnt-lb">{{$t('tour.return_date')}}</label>
                                        <div class="tb-cnt-txt"></div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="error-message-voucher" v-if="errorMessage">
                        <div class="d-flex">
                            <i class="icon-warning mr-2"></i>
                            <div class="errror-txt">
                                <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                                <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SearchTour from "@/views/layout/pc/Tour/Search";
import StorageService from "@/services/common/storage.service";
import TourManagementService from "@/services/module/tour.service";
import InfoService from '@/services/admin/infos.service';
import { TheMask } from "vue-the-mask";
import router from "@/router";
import Utils from "@/helpers/utils";
import { AuthService } from "@/services/common/auth.service";
import { Role } from '@/helpers/role';

export default {
    components: {
        TheMask,
        SearchTour },
    name: "PcSearchTour",
    data () {
        const storageUser = JSON.parse(StorageService.getUser());
        let user = null;
        if (storageUser) {
            const last_login = storageUser.last_login ? storageUser.last_login.replace(/-/g, '/') : '';
            const last_update_pass_time = storageUser.last_update_pass_time ? storageUser.last_update_pass_time.replace(/\./g, '/') : '';
            const userInfo = {
                last_login: last_login,
                last_update_pass_time: last_update_pass_time
            }
            user = userInfo;
        }
        return {
            keyword_search: "",
            masked: true,
            errorMessage: "",
            user: user,
            isNotify: false,
            infos: {},
        };
    },
    computed: {},
    beforeCreate () {
        const role = StorageService.getUserRole();
        if (role == Role.PwReset.id) {
            router.push('/admin/users');
        } else {
            let cashId = StorageService.getCashId();
            let tour = JSON.parse(StorageService.getTour());
            if (Utils.isEmptyStr(cashId)) {
                if (!Utils.isEmptyObj(tour)) {
                    router.push("/tour/after-input?search=" + tour.tour_number);
                }
            } else {
                // router.push("/cash/list-carry?cashId=" + cashId);
                router.push("/voucher/list");
            }
        }
    },
    created () {
    },
    methods: {
        searchTour (e) {
            this.$router.push("/tour/after-input?search=" + this.keyword_search);
        },
    },
    mounted () {
        InfoService.getInfo().then(response =>{
            if (response.status == 423) {
                StorageService.saveExpired();
                AuthService.doLogout();
            }
            if (response.status == 200) {
                this.infos = response.data;
                if (this.infos) {
                    this.isNotify = this.infos.is_notify;
                    // this.infos.body = (this.infos.body).replace(/n/g, '<br>');
                } else {
                    this.isNotify = false;
                }
            }
        })
    },
    watch: {
        'keyword_search': function () {
            const reg = /\d{9}/;
            if (this.keyword_search.match(reg)) {
                this.keyword_search = this.keyword_search.substr(0, 6) + '-' + this.keyword_search.substr(6);
            }
        },
        'infos.body' : function () {
            this.infos.body = (this.infos.body).replace(/\n/g, '<br>');
        }
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Tour/Input.vue